import { Tag } from '@applyboard/crystal-ui'

type ProgramLengthProps = Readonly<{
  length: number
  unit: 'years' | 'months' | 'weeks'
}>

export function ProgramLength(props: ProgramLengthProps) {
  switch (props.unit) {
    case 'years':
      return <Tag intent="secondary" size="md">{`${props.length}-Years`}</Tag>
    case 'months':
      return <Tag intent="secondary" size="md">{`${props.length}-Months`}</Tag>
    case 'weeks':
      return <Tag intent="secondary" size="md">{`${props.length}-Weeks`}</Tag>
    default:
      return null
  }
}
